<template>
  <a-select
      show-search
      placeholder="请选择公司"
      option-filter-prop="children"
      style="width: 155px"
      size="large"
      :filter-option="false"
      :getPopupContainer="trigger => trigger.parentNode"
      @popupScroll="goodsScroll"
      @search="fetchCompany"
      @change="chooseOption"
      :value="currentValue.label?currentValue:undefined"
      label-in-value>
    <a-select-option v-for="(item,index) in companyList" :key="index" :value="item.id">
      {{item.name}}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: "companySelector",
  props:{
   currentValue:{
      type:Object,
    }
  },
  data(){
    return{
      companyList: [],
      queryParam:{
        current:1,
        size:20,
        name:'',
      },
      selectOption:'',
      text:'',
    }
  },
  created() {
    this.getCompanyDropDownList(this.queryParam);
  },
  methods:{
    chooseOption(value){
      this.$emit('companySelectChange',value);
    },
    fetchCompany(value){
      const params = {
        current:1,
        size:this.queryParam.size,
        name:value,
      }
      this.getCompanyDropDownList(params);
    },
    goodsScroll(e){
      const { target } = e;
      if(target.scrollTop+target.offsetHeight===target.scrollHeight){
        const nextIndex = this.queryParam.current+1;
        this.setIndex(nextIndex);
        this.getCompanyDropDownList(this.queryParam)
      }
    },
    setIndex(index){
      this.queryParam.current = index;
    },
    getCompanyDropDownList(params){
      this.$api.supplier.supplierBindCompanyDropDownList(params).then(res => {
        if (res.code === 200 && res.success) {
          this.companyList = res.data.records;
        }
      });
    },
  },
  watch:{
    currentValue(val){
      this.text = val.label;
    }
  }
}
</script>

<style scoped>

</style>